export default ({ countFor200, countFor250, countFor500 }) => {
  const merged = [
    ...countFor200,
    ...countFor250,
    ...countFor500
  ]
  const filtered = merged.sort((a, b) => a.forceTime > b.forceTime ? 1 : -1)
  const sum200 = countFor200.reduce((acc, i) => Number(acc) + Number(i.creditPaid.amountPaid), 0)
  const sum250 = countFor250.reduce((acc, i) => Number(acc) + Number(i.creditPaid.amountPaid), 0)
  const sum500 = countFor500.reduce((acc, i) => Number(acc) + Number(i.creditPaid.amountPaid), 0)

  return {
    mergedCounts: filtered,
    sum200,
    sum250,
    sum500
  }
}